<template>
  <div>
    <p class="products-title">
      {{ $t('lps.product.chooseProductText') }}
    </p>
    <div
      v-for="product in products"
      :key="product.product.productId"
      class="pack"
      :class="{popular: product.popular}"
      @click="$emit('updateSelectedProduct', { ...product })"
    >
      <div
        v-if="product.product.productId === selectedProduct.id"
        class="pack-selected"
      />
      <div :class="product.popular ? 'popular-tag' : 'pack-title'">
        {{ $t(product.name) }}
      </div>
      <div
        v-if="product.discount"
        class="discount-tag"
      >
        <span>
          %{{ product.discount }}
        </span>
        <img
          src="@/assets/images/lps/percent.png"
          alt="percent"
        >
      </div>
      <div class="pack-content">
        <div class="pack-details">
          <span
            class="radio"
            :class="{selected: product.product.productId === selectedProduct.id}"
          />
          <span class="diamonds">
            {{ numberFormat(product.product.credits) }} {{ $t('Diamonds') }}
            <b-img
              :src="iconDiamonds3"
              height="24"
            />
          </span>
        </div>
        <div class="price">
          <div class="current-price">
            {{ product.product.currency === 'USD' ? '$' : '&#8378;' }}
            {{ product.product.amount }}
          </div>
          <div class="original-price">
            {{ product.product.currency === 'USD' ? '$' : '&#8378;' }}
            {{ getOldPrice(product) }}
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 0 10px">
      <b-button
        class="mt-2"
        type="submit"
        variant="primary"
        style="background-color: #AC33F4 !important; color: #fff !important; padding: 16px; border-radius: 16px;"
        block
        :disabled="loading || !selectedProduct"
        @click="updateActiveStep(3)"
      >
        <b-spinner
          v-if="loading"
          small
        />
        {{ $t('Continue') }}
      </b-button>
    </div>

    <div class="d-flex justify-content-around mt-2">
      <p class="color-green">
        {{ $t('Pay safe & secure') }}
      </p>
      <router-link
        v-if="showLoginUrl"
        :to="{name: 'login'}"
        style="color: #AC33F4 !important; text-decoration: underline; font-weight: bold;"
      >
        {{ $t('Already a Member?') }}
      </router-link>
    </div>

    <div
      class="text-center"
      style="background-color: #F4E0FF !important; border: 2px solid #AC33F4; padding: 16px; border-radius: 16px;"
    >
      <img
        src="@/assets/images/logo/logo.png"
        alt="boho logo"
        style="width: 90px; height: 50px;"
      >
      <p class="font-lobster mt-1 fs-22">
        {{ $t('lps.product.Users Love Boho') }} <br>
        {{ $t('lps.product.Experience Now and Have Fun!') }}
      </p>
    </div>
    <div class="lp-comments">
      <LpComment
        v-for="(comment, index) in comments"
        :key="index"
        :data="comment"
      />
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BImg,
  BSpinner,
} from 'bootstrap-vue'
import {
  numberFormat,
} from '@/helpers/helpers'
import LpComment from '@/components/Lp/LpComment.vue'

const iconDiamonds3 = require('@/assets/images/icons/diamonds-3.svg')

export default {
  name: 'LpProducts',
  components: {
    BButton,
    BImg,
    BSpinner,
    LpComment,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    products: {
      type: Array,
      default: () => ([]),
    },
    showLoginUrl: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      comments: [
        {
          avatar: this.$t('lps.comment1.avatar'),
          avatarColor: '#410b57',
          comment: this.$t('lps.comment1.comment'),
          date: this.$t('lps.comment1.date'),
          name: this.$t('lps.comment1.name'),
          title: this.$t('lps.comment1.title'),
        },
        {
          avatar: this.$t('lps.comment2.avatar'),
          avatarColor: '#0e48a6',
          comment: this.$t('lps.comment2.comment'),
          date: this.$t('lps.comment2.date'),
          name: this.$t('lps.comment2.name'),
          title: this.$t('lps.comment2.title'),
        },
        {
          avatar: this.$t('lps.comment3.avatar'),
          avatarColor: '#747481',
          comment: this.$t('lps.comment3.comment'),
          date: this.$t('lps.comment3.date'),
          name: this.$t('lps.comment3.name'),
          title: this.$t('lps.comment3.title'),
        },
      ],
      iconDiamonds3,
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user']
    },
  },
  methods: {
    numberFormat,
    getOldPrice(product) {
      let discountRate = 0.4

      if (product.discount) {
        // eslint-disable-next-line radix
        discountRate = parseFloat(parseInt(product.discount) / 100)
      }
      const basePrice = Math.floor(parseFloat(product.product.amount / (1 - discountRate)) / 10) * 10

      // eslint-disable-next-line radix
      return (basePrice + 9.99).toFixed(2)
    },
    updateActiveStep(step = 3) {
      this.$emit('updateActiveStep', step)
    },
  },
}
</script>
